// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview-box{height:100%}`, "",{"version":3,"sources":["webpack://./src/components/preview-box/preview-box.css"],"names":[],"mappings":"AAAA,aACC,WAGD","sourcesContent":[".preview-box {\n\theight: 100%;\n\n\t/* Should have a parent with 'pointer-events: none' to click through to the background preview */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
